/**
 * Central product copy for Contractor Growth Kit.
 * Change wording here instead of hardcoding in components or emails.
 */
export const STRINGS = {
  product: {
    name: 'Contractor Growth Kit',
    tagline: "See what's costing your website customers, and fix it this week, on the site you already have.",
    shortPromise: 'Find what is costing you customers — then fix it on the site you already have.',
  },
  landing: {
    ctaCheckWebsite: 'Check my website',
    reassurance: 'We only read your public pages.',
    findFixWin: {
      find: 'Find what is costing you customers',
      fix: 'Fix it with practical kits',
      win: 'Win more jobs with quotes, reviews, and proof',
    },
  },
  auth: {
    verifySubject: 'Verify your email',
    resetSubject: 'Reset your password',
    passwordMinHint: 'Use at least 10 characters.',
    lockout: 'Too many failed attempts. Try again in 15 minutes.',
  },
  review: {
    startTitle: 'Website Growth Review',
    startHint: 'Paste your website URL. We will not crawl until you start.',
    readyEmail: 'Your website growth review is ready',
    couldNotCheck: 'Could not check',
    botBlocked: 'We could not reach your site (bot protection). No problems were recorded.',
  },
  quote: {
    newRequestSubject: 'New quote request',
    inboxEmpty: 'No quote requests yet.',
    published: 'Your quote request page is live.',
    paused: 'This page is not accepting requests right now.',
    businessModel:
      "This page works wherever you share it: on your website, in texts and emails, on a QR code, on your truck, or in your Google Business Profile — it doesn't depend on other site traffic.",
    outsideArea: 'Outside your usual service area — still accepted.',
    notifyUnverified: 'Notifications are off until this email is verified.',
  },
  proof: {
    consentRequired: 'Customer consent is required before publishing.',
    reviewRequestCopied: 'Message copied. Send it from your own email or text.',
    sectionTitle: 'Reviews & Project Proof',
    sectionSubtitle: 'Ask for reviews and showcase real work.',
    qrTrackingNote:
      "This link only sends people to your review page. We don't track or filter who clicks.",
    qrOptionalClicks: 'Optional anonymous click count is visible only to you.',
    honestyNotice:
      'Messages stay neutral — no 5-star asks, gifts, or “only if you’re happy” wording (Google and FTC rules).',
    photoReminder:
      'Check your photos for faces, license plates, house numbers, and personal items before sharing.',
    ownerProvidedFootnote: 'Owner-provided project',
    referralTrackingNote:
      'We only count anonymous link opens if you turn that on. We do not claim attributed leads or confirmed referrals.',
    socialComingSoon: 'Handle your Google Business Profile and social pages — coming soon.',
    revokeHidesEverywhere: 'Consent revoked — this project is hidden everywhere immediately.',
  },
  settings: {
    yourData: 'Your data',
    exportReady: 'Your data export is ready',
    deletionConfirm: 'Account deletion confirmation',
    planFree: 'Plan: Free',
    privacySummary:
      "We don't sell your data or your customers' data. We don't publish anything without your approval.",
  },
  home: {
    referralLine: "Know another contractor who'd want a free website check-up? Share your link.",
    comingSoonStrip:
      'Coming soon: connect Google Search Console and Analytics, AI content help, and social media handling.',
    outcomesFind: 'Find problems on the site you already have',
    outcomesFix: 'Fix them in minutes with ready-to-edit drafts',
    outcomesWin: 'Get clearer customer requests and reviews',
  },
  earlyAccess: {
    confirmation: 'Thanks — we received your early access request.',
    notAvailable: 'Not available yet.',
    socialOnList: "You're on the list. We'll reach out when we open the first group.",
    socialHonesty: "This isn't available yet. We're building it with contractors like you.",
  },
  social: {
    title: 'Social media help',
    promise:
      "We'll help you look professional where customers find you: Google Business Profile, Facebook, Instagram and YouTube.",
  },
  improvement: {
    sectionTitle: 'Website Improvement Kit',
    sectionSubtitle: 'Ready-to-edit drafts you can paste into the site you already have.',
    factsBanner: 'We only use what you tell us. Nothing is invented. Leave blank anything you’d rather not show.',
    comingSoonTitle: 'Coming soon: smarter website help',
    comingSoonBadge: 'Coming soon',
    markDone: 'I added this to my website',
    recheckOffer: 'Re-run review to check it’s working',
  },
  errors: {
    unauthorized: 'Sign in to continue.',
    forbidden: 'You do not have access to this business.',
    notFound: 'Not found.',
    rateLimited: 'Too many requests. Please try again later.',
    storageUnavailable: 'File storage is not configured yet.',
  },
} as const;

export type StringTree = typeof STRINGS;
